const moment = require('moment')
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("servidor_publico", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.servidor_publico + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_incorporacion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (moment(item.fecha_incorporacion).format('DD/MM/YYYY') + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("saldo_corte", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.saldo_corte + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("dias_asignados", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.dias_asignados + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("dias_programar", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.dias_programar + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            return cf.runFilters();
        },
        
        filterServidorPublico(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                servidor_publico: val
            });
        },
        filterFechaIncorporacion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_incorporacion: val
            });
        },
        filterSaldoCorte(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                saldo_corte: val
            });
        },
        filterDiasAsignados(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias_asignados: val
            });
        },
        filterDiasProgramar(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias_programar: val
            });
        },

        recargar(){
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                servidor_publico: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_incorporacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                saldo_corte: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias_asignados: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias_programar: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/vacaciones/mixins/filtros.js